import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import {
  fetchRestaurantAsync,
  getRestaurantSelectors,
} from '../../features/manager/restaurantList/restaurantSlice';

export const useRestaurant = (restaurantId: string) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const restaurantSelectors = getRestaurantSelectors();
  const restaurants = useAppSelector(restaurantSelectors.selectAll);
  const restaurant = restaurants.find((r) => r.id === restaurantId);

  const fetchRestaurants = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await dispatch(fetchRestaurantAsync(restaurantId)).unwrap();
    } catch (err) {
      setError(typeof err === 'string' ? err : 'Failed to fetch restaurants');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!restaurant) {
      fetchRestaurants();
    }
  }, [restaurantId]);

  return {
    restaurant,
    isLoading,
    error,
    retry: fetchRestaurants,
  };
};
